<template>
  <div class="appointment-repeat-con">
    <ul>
      <!-- Repeat every -->
      <li v-if="requiredCustomInput">
        <div class="con-lhs">Repeat Every:</div>
        <input class="con-rhs" type="number" v-model="repeatEvery" />
        <div class="clear"></div>
      </li>

      <!-- Start date -->
      <li @click="editDate('start')">
        <div class="con-lhs starts-on">Starts On:</div>
        <input
          class="hidden-date"
          type="date"
          ref="startDateRef"
          :value="startDate.toString()"
          @change="dateChanged($event, 'start')"
        />
        <div class="con-rhs">
          {{ moment(startDate).format("MMM DD, YYYY") }}
        </div>
        <div class="clear"></div>
      </li>

      <!-- End date -->
      <li @click="editDate('end')">
        <div class="con-lhs">Ends On:</div>
        <input
          class="hidden-date"
          type="date"
          ref="endDateRef"
          :value="endDate === '' ? '' : moment(endDate).format('YYYY-MM-DD')"
          @input="dateChanged($event, 'end')"
        />
        <div class="con-rhs">
          {{
            endDate === "" ? "Never" : moment(endDate).format("MMM DD, YYYY")
          }}
        </div>
        <div class="clear"></div>
      </li>

      <li v-if="requiredWeekSelect">
        <div class="con-lhs">Repeat On :</div>
      </li>

      <li v-if="requiredMonthSelect">
        <div class="con-lhs">Repeat By :</div>
      </li>

      <!-- Weekly selector -->
      <li v-if="requiredWeekSelect" class="days-to-be-repeated">
        <span class="day-container">
          <span class="toggle" v-for="day in weekDays" :key="day.id">
            <input
              type="checkbox"
              :name="day.value"
              class="input-btn"
              :id="`checkbox-${day.value.toLowerCase()}`"
              @change="weekSelected(day, $event)"
              :checked="day.selected"
            />
            <label
              class="slide-toggle slide-toggle-appoitment"
              :for="`checkbox-${day.value.toLowerCase()}`"
            ></label>
            <span class="checkbox-label">{{ day.value }}</span>
          </span>
        </span>
      </li>

      <!-- Month select -->
      <li v-if="requiredMonthSelect">
        <span class="day-container">
          <span class="toggle months" v-for="type in monthTypes" :key="type.id">
            <input
              type="checkbox"
              :name="type.value"
              class="input-btn"
              :id="`checkbox-${type.value.toLowerCase()}`"
              @change="monthSelected(type.id, $event)"
              :checked="type.selected"
            />
            <label
              class="slide-toggle slide-toggle-appoitment"
              :for="`checkbox-${type.value.toLowerCase()}`"
            ></label>
            <span class="checkbox-label">{{ type.value }}</span>
          </span>
        </span>
      </li>

      <!-- Save -->
      <li @click="save">
        <a href="#" @click.prevent class="cta-primary">Save</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";

export default {
  name: "RepeatInner",
  props: {
    done: Function, // Closes the inner panel
    requiredCustomInput: Boolean, // Weather to show the custom imput or not
    requiredWeekSelect: Boolean, // Weather weekly select is required
    requiredMonthSelect: Boolean // Weather month select is required
  },
  data() {
    return {
      /**
       * All the week days
       */
      weekDays: [
        { id: 1, value: "Mon", selected: false },
        { id: 2, value: "Tue", selected: false },
        { id: 3, value: "Wed", selected: false },
        { id: 4, value: "Thu", selected: false },
        { id: 5, value: "Fri", selected: false },
        { id: 6, value: "Sat", selected: false },
        { id: 0, value: "Sun", selected: false }
      ],
      /**
       * Mothly option
       */
      monthTypes: [
        { id: 0, value: "Day of the month", selected: true },
        { id: 1, value: "Day of the week", selected: false }
      ],
      /**
       * Repeat every
       */
      repeatEvery: 1,
      /**
       * Start date local
       */
      startDate: "",
      /**
       * End date local
       */
      endDate: ""
    };
  },
  computed: {
    ...mapGetters({
      repeat: "getRepeat", // Repeat details
      permStart: "getStartRepeat", // Permanent start date
      permEnd: "getEndRepeat" // Permanent end date
    })
  },
  methods: {
    ...mapMutations({
      setRepeatCustom: "setRepeatCustom", // Set the custom inner
      setStartDate: "setStartRepeat", // Set the start date
      setEndDate: "setEndRepeat", // Set the end date
      setRepeatWeeklyOn: "setRepeatWeeklyOn", // Set weekly repeat global
      setFullMonthlyType: "setFullMonthlyType" // Set the full type
    }),
    /**
     * Edit date
     */
    editDate(startOrEnd) {
      if (startOrEnd === "start") {
        this.$refs.startDateRef.focus();
        this.$refs.startDateRef.click();
      } else {
        this.$refs.endDateRef.focus();
        this.$refs.endDateRef.click();
      }
    },
    /**
     * When date is changed
     */
    dateChanged(event, startOrEnd) {
      if (startOrEnd === "start") {
        this.startDate =
          event.target.value === "" ? "" : new Date(event.target.value);
      } else {
        this.endDate =
          event.target.value === "" ? "" : new Date(event.target.value);
      }
    },
    /**
     * When the week day is selected
     */
    weekSelected(obj, event) {
      obj.selected = event.target.checked;
    },
    /**
     * When monthly option is changed
     */
    monthSelected(id, event) {
      this.monthTypes = this.monthTypes.map(type => {
        if (type.id === id) {
          return { ...type, selected: event.target.checked };
        }
        return { ...type, selected: !event.target.checked };
      });
    },
    /**
     * Save all the details
     */
    save() {
      // Step 1: Save custom
      this.setRepeatCustom(this.repeatEvery);

      // Step 2: Set start date
      this.setStartDate({
        dayOfMonth: this.startDate.getDate(),
        month: this.startDate.getMonth(),
        year: this.startDate.getFullYear()
      });

      // Step 3: Set end date
      if (this.endDate !== "") {
        this.setEndDate({
          dayOfMonth: this.endDate.getDate(),
          month: this.endDate.getMonth(),
          year: this.endDate.getFullYear(),
          never: false
        });
      } else {
        this.setEndDate({
          dayOfMonth: 0,
          month: 0,
          year: 0,
          never: true
        });
      }

      // Step 4: Set all the weekly repeat
      this.weekDays.forEach(day => {
        if (day.selected) {
          this.setRepeatWeeklyOn({ index: day.id, value: true });
        } else {
          this.setRepeatWeeklyOn({ index: day.id, value: false });
        }
      });

      // Step 5: Set the monthly permanent type
      this.monthTypes.forEach(type => {
        if (type.selected) {
          const value =
            type.id === 0 ? "Monthly - day of month" : "Monthly - day of week";
          this.setFullMonthlyType(value);
        }
      });

      // Step 4: Close the panel
      this.done();
    },
    /**
     * Moment available
     */
    moment(value) {
      return moment(value);
    }
  },
  created() {
    // Base setup
    if (this.repeat.custom <= 0) {
      this.setRepeatCustom(1);
    }
    this.repeatEvery = this.repeat.custom;
    this.startDate = new Date(
      this.permStart.year,
      this.permStart.month,
      this.permStart.dayOfMonth
    );
    this.weekDays = this.weekDays.map(day => {
      return {
        ...day,
        selected: day.id === this.startDate.getDay()
      };
    });
    this.endDate = this.permEnd.never
      ? ""
      : new Date(
          this.permEnd.year,
          this.permEnd.month,
          this.permEnd.dayOfMonth
        );
    const monthlyOpt = this.repeat.fullMonthlyType;
    const weeklyOn = this.repeat.weeklyOn;
    this.weekDays = this.weekDays.map(day => {
      if (weeklyOn[day.id]) {
        return { ...day, selected: true };
      }
      return { ...day };
    });
    if (monthlyOpt === "Monthly - day of month") {
      this.monthTypes = this.monthTypes.map(type => {
        if (type.id === 0) {
          return {
            ...type,
            selected: true
          };
        }
        return { ...type, selected: false };
      });
    } else if (monthlyOpt === "Monthly - day of week") {
      this.monthTypes = this.monthTypes.map(type => {
        if (type.id === 1) {
          return {
            ...type,
            selected: true
          };
        }
        return { ...type, selected: false };
      });
    }
  }
};
</script>

<style scoped>
.appointment-repeat-con {
  margin: 10px 0;
  position: relative;
  overflow: hidden;
  background: #f8f8f8;
  border: 1px solid #dadada;
  max-width: 400px;
  width: 96%;
}
.appointment-repeat-con ul {
  list-style: none;
  padding: 10px 15px;
  margin: 0;
}
.appointment-repeat-con ul li {
  margin: 6px 0;
  clear: both;
  font-size: 15px;
}
.appointment-repeat-con ul li .con-lhs {
  float: left;
  width: 110px;
  text-align: left;
  font-weight: bold;
}
.appointment-repeat-con ul li .con-lhs.starts-on {
  width: 80px;
}
.appointment-repeat-con ul li .con-rhs {
  float: right;
  text-align: right;
  background: transparent;
  border: none;
  outline: none;
}
.appointment-repeat-con ul li input.con-rhs {
  max-width: 30px;
}
.appointment-repeat-con ul li .clear {
  clear: both;
}
.appointment-repeat-con ul li a {
  text-align: right;
  display: inline-block;
  font-weight: bold;
  padding-bottom: 5px;
}
.appointment-repeat-con ul li:last-child() {
  margin: 0 0 20px 0;
}
.appointment-repeat-con ul li a.cta-primary {
  float: right;
}
.appointment-repeat-con span.day-container {
  padding: 0 !important;
}
.appointment-repeat-con li.days-to-be-repeated {
  padding: 0 !important;
  margin: 0;
}

.hidden-date {
  opacity: 0;
  height: 0;
  width: 0;
}

.slide-section-inner-wrapper ul li span:last-of-type {
  border: none;
}

.slide-section-inner-wrapper ul li span:last-of-type {
  width: auto;
}

.day-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border: none;
}

.toggle {
  width: auto;
  min-width: 70px;
  float: none !important;
}

.toggle.months {
  min-width: 200px;
}

.checkbox-label {
  margin-left: 20px;
  margin-top: 3px;
}
</style>
